$giper_balls_lines $giper_balls_game
	title @ \Lines
	auto /
		<= add_new null
	cell_start? /
